// ./Components/CrossPortalNoticeModal.js
// Shown once per login (see Authentication.login's own
// crossPortalNoticeDismissed reset) when this carrier's clients/carriers
// span both cpv2 and cpv3 -- see V3_PLANNING.md's "Client version routing".
// Mirrors carrier-portal-frontend-3's own CrossPortalNoticeModal.jsx, built
// on this app's own established react-bootstrap Modal pattern (see
// GenericModal.js) instead of that app's Radix Dialog, which doesn't exist
// here. show/onHide are parent-owned state, same convention as every other
// modal in this codebase (ProfileModal.js etc.) -- not internal modal state.

import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import CrossPortalCards from "./CrossPortalCards";
// .portalChooserExplanation is defined there, reused here rather than
// duplicated -- explicit import so this doesn't silently depend on
// PortalChooser.js happening to be loaded first elsewhere in the bundle.
import "../Pages/PortalChooser/PortalChooser.css";

function CrossPortalNoticeModal({ show, onHide, notice, thisPortalClients }) {
  if (!notice) return null;

  return (
    <Modal show={show} onHide={onHide} size="lg" scrollable="true">
      <Modal.Header closeButton>
        <Modal.Title>Carrier Portal: Legacy Version &amp; New Version</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="portalChooserExplanation">{notice.explanation.en}</div>
        <CrossPortalCards
          thisPortalClients={thisPortalClients}
          otherPortalClients={notice.otherPortalClients}
          otherPortalUrl={notice.otherPortalUrl}
          // Already showing ON /Dashboard -- a real navigation there is a
          // no-op that would leave this modal sitting open over content
          // that didn't visibly change. Just dismiss instead.
          onContinueClick={onHide}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-primary" className="allBtn" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default CrossPortalNoticeModal;
